/** "smooth" for scrolling, unless the device has been asked for less movement. */
export const scrollBehavior = () => { var _a; return ((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)").matches) ? "auto" : "smooth"; };
